import healthCoach from '../../api/health_coach'
import Vue from 'vue'
import VueToast from 'vue-toast-notification'
Vue.use(VueToast)

// STATE
const state = {
  programDetails: {},
  addGoals: [
    { name: 'Weight', units: 'kgs', target_value: '' },
    { name: 'Blood Pressure', units: 'mmHg', target_value: '' },
    { name: 'Blood Sugar', units: 'mg/dl', target_value: '' },
    { name: 'Triglycerides', units: 'mmol/L', target_value: '' },
    { name: 'HbA1c', units: 'mmol/mol', target_value: '' }
  ],
  goals: [],
  vitals: [],
  progress: [],
  currentVitalsWeek: '',
  timelineAndProgress: {},
  dailySteps: [],
  weeklySteps: []
}

// GETTERS
const getters = {
  getProgramDetails () {
    return state.programDetails
  },
  getVitalsWeek () {
    return state.currentVitalsWeek
  },
  getCurrentGoals () {
    return state.goals
  },
  getAddGoals () {
    return state.addGoals
  },
  getVitals () {
    return state.vitals
  },
  getProgress () {
    return state.progress
  },
  getDailySteps () {
    return state.dailySteps
  },
  getWeeklySteps () {
    return state.weeklySteps
  },
  getTimelineAndProgress () {
    return state.timelineAndProgress
  }
}

// ACTIONS
const actions = {
  healthCoachInitialState ({ commit }, { data }) {
    commit('setInitialState', data)
  },
  setCustomerVitals ({ commit }, { data }) {
    commit('setVitals', data)
  },
  setDailyCustomerSteps ({ commit }, { data }) {
    commit('setDailySteps', data)
  },
  setWeeklyCustomerSteps ({ commit }, { data }) {
    commit('setWeeklySteps', data)
  },
  setTimelineAndProgress ({ commit }, { data }) {
    commit('setTimelineProgress', data)
  },
  addGoal ({ commit }, { val }) {
    let data = {
      name: val.name,
      target_value: val.target_value,
      program_enrollment_id: state.programDetails.programEnrollmentId
    }
    healthCoach.createGoal(data).then(res => {
      if (res.status === 200) {
        if (res.body.goal) {
          commit('addGoal', res.body.goal)
        } else {
          Vue.$toast.open({
            message: res.body.message,
            type: 'error',
            position: 'top',
            queue: false
          })
        }
      }
    })
  },
  updateGoal ({ commit }, { programEnrollmentId, val }) {
    let healthCoachGoalsData = {
      goals: val.map(goal => ({
        id: goal.id,
        target_value: goal.target_value
      }))
    }

    healthCoach.bulkUpdateGoal(programEnrollmentId, healthCoachGoalsData).then(res => {
      if (res.status === 200) {
        commit('updateGoal', res.body.goals)
      } else {
        console.error('Failed to update goals:', res.body.message)
      }
    }).catch(error => {
      console.error('Error updating goals:', error)
    })
  },
  deleteGoal ({ commit }, { goal }) {
    if (goal.id) {
      healthCoach.deleteGoal(goal.id).then(res => {
        if (res.status === 200) {
          commit('deleteGoal', goal)
        }
      })
    } else {
      state.goals = state.goals.filter((ele) => ele.name !== goal.name)
    }
  },
  changeVitalsWeek ({ commit }, { week }) {
    commit('changeVitalsWeek', week)
  },
  reset (state) {
    state = {}
  }
}

// MUTATIONS
const mutations = {
  setInitialState (state, data) {
    state.programDetails = {
      programName: data.program_name,
      programType: data.program_type,
      duration: `${data.duration} ${data.duration_type}`,
      currentWeek: data.week,
      programEnrollmentId: data.program_enrollment_id,
      startOfWeek: data.start_of_week,
      enrollmentDate: data.enrollment_date
    }
    state.goals = data.goals
    state.addGoals = state.addGoals
    state.progress = data.progress
    state.currentVitalsWeek = state.programDetails.currentWeek.slice(5)
  },
  setVitals (state, data) {
    state.vitals = data.customer_goal_vitals
  },
  setDailySteps (state, data) {
    state.dailySteps = data
  },
  setWeeklySteps (state, data) {
    state.weeklySteps = data
  },
  addGoal (state, val) {
    state.goals.push(val)
  },
  updateGoal (state, goal) {
    state.goals = state.goals.map(ele => ele.id === goal.id ? goal : ele)
  },
  deleteGoal (state, goal) {
    state.goals = state.goals.filter((ele) => ele.id !== goal.id)
    state.addGoals = state.addGoals.map((ele) => {
      if (ele.name === goal.name) {
        ele.target_value = ''
      }
      return ele
    })
  },
  changeVitalsWeek (state, week) {
    // Changing vitals with week
    state.currentVitalsWeek = week.toString()
  },
  setTimelineProgress (state, data) {
    state.timelineAndProgress = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/health_coach.js